import React, { Component } from 'react';
import Translations from "../../translations/translations.json";
import { connect } from 'react-redux';

class Logout extends Component {
    constructor(props, context) {
        super(props, context);

        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);

        this.state = {
          show: false
        };
    }

    handleClose() {
      this.setState({ show: false });
    }

    handleShow() {
      this.setState({ show: true });
    }
    
  render() {
    return (
      <div>
        Logout
      </div>
    )
  }
}

const mapStateToProps = state => ({
    lang: state.reducerLang.lang
});
export default connect(mapStateToProps)(Logout);